/**
 * Generated runtime TestId mirror for frontend/src/components/violations/SeverityBadge.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SeverityBadgeTestIds = {
  severityBadgeCritical: "severity-badge-critical",
  severityBadgeError: "severity-badge-error",
  severityBadgeLink: "severity-badge-link",
  severityBadgeReferenceBroken: "severity-badge-reference-broken",
  severityBadgeRow: "severity-badge-row",
  severityBadgeWarn: "severity-badge-warn",
  severityBadgeZero: "severity-badge-zero"
} as const;
